import { createAsyncThunk } from '@reduxjs/toolkit';
export const createSliceRequest = (name, func) => {
    return createAsyncThunk(name, async (arg, { rejectWithValue }) => {
        var _a, _b, _c, _d, _e;
        try {
            return await func(arg);
        }
        catch (error) {
            console.error(`[${name}] Error:`, error);
            const errorObj = error;
            const appError = {
                code: ((_b = (_a = errorObj.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error_code) ||
                    errorObj.code ||
                    'UNKNOWN_ERROR',
                message: ((_d = (_c = errorObj.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
                    errorObj.message ||
                    'An unknown error occurred',
                details: (_e = errorObj.response) === null || _e === void 0 ? void 0 : _e.data,
            };
            return rejectWithValue(appError);
        }
    });
};
